import * as styles from "./ParagraphButton.module.scss";

import { graphql } from "gatsby";
import React, { useCallback } from "react";
import { Button } from "../../../components/common";
import type { ButtonVariant } from "../../../components/common/Button/Button";
import { Chevron } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphButtonProps {
	theme: string;
	linkUrl: string;
	linkTitle: string;
	icon: string;
	isSection: boolean;
	parentTheme?: DogsTrust.ContentSectionThemes;
}

export const getParagraphButtonProps = (
	{
		field_button_theme,
		field_link,
		field_button_icon,
	}: Queries.ParagraphButtonDataFragment,
	isSection: boolean,
	parentTheme?: DogsTrust.ContentSectionThemes,
): ParagraphButtonProps => ({
	theme: field_button_theme,
	linkUrl: field_link.uri,
	linkTitle: field_link.title,
	icon: field_button_icon,
	isSection,
	parentTheme,
});
export const ParagraphButton: React.FC<ParagraphButtonProps> = ({
	theme,
	linkUrl,
	linkTitle,
	icon,
	isSection,
}) => {
	const getVariant = useCallback((): DogsTrust.ButtonVariant => {
		return theme === "primary" ? "tertiary" : "secondary";
	}, [theme]);

	const getIconColour = useCallback(() => {
		switch (theme) {
			case "primary":
				return Colours.MIDNIGHT;
			default:
				return Colours.WHITE;
		}
	}, [theme]);

	const ButtonComponent = useCallback(
		() => (
			<div className={styles.buttonwrapper}>
				<Button
					variant={getVariant()}
					url={linkUrl}
					fullWidth={true}
					IconRight={
						icon === "chevronNext"
							? () => (
									<Chevron
										rotation={90}
										fill={getIconColour()}
										height={"25px"}
										width={"25px"}
									/>
								)
							: undefined
					}
					IconLeft={
						icon === "chevronBack"
							? () => (
									<Chevron
										rotation={-90}
										fill={getIconColour()}
										height={"25px"}
										width={"25px"}
									/>
								)
							: undefined
					}
				>
					{linkTitle}
				</Button>
			</div>
		),
		[linkTitle, linkUrl, getVariant, getIconColour, icon],
	);

	if (isSection) {
		return (
			<WrappedSection sectionName="ParagraphButton">
				<div className={styles.sectionwrapperinner}>
					<ButtonComponent />
				</div>
			</WrappedSection>
		);
	}

	return <ButtonComponent />;
};

export default ParagraphButton;

export const fragment = graphql`
    fragment ParagraphButtonData on paragraph__link_button {
        __typename
        id
        field_link {
            title
            uri
        }
        field_button_theme
        field_button_icon
    }
`;
